<template>
    <div>
        <DocumentTable
            :rows="documents"
            :type.sync="type"
            :searchTerm.sync="searchTerm"
            :page="page"
            :length="length"
            :total="total"
            :loading="loading"
            :error="error"
            @search="searchDocuments"
            @clear="clearSearch"
            @refresh="loadDocuments"
            @page-change="changePage"
            @size-change="changeLength"
            @row-click="rowClick"
        >
            <template #connection>
                <el-radio-group v-if="checkSystemSupport" v-model="connection" size="small" class="mb-2">
                    <el-radio-button label="QATL_PRODUCTION">QATL_PRODUCTION</el-radio-button>
                    <el-radio-button label="QATL_DEV">QATL_DEV</el-radio-button>
                </el-radio-group>
            </template>
        </DocumentTable>
        <DocumentForm ref="moduleForm" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { userData } from '../../helpers/user';
import DocumentTable from './Table.vue';
import DocumentForm from './Form.vue';

export default {
    name: 'InTransitDocuments',
    components: { DocumentTable, DocumentForm },
    data() {
        return {
            user: userData(),
            connection: 'QATL_PRODUCTION',
            type: 'grn',
            documents: [],
            searchTerm: '',
            appliedTerm: '',
            page: 1,
            length: 25,
            total: 0,
            loading: false,
            error: '',
            requestId: 0
        };
    },
    computed: {
        checkSystemSupport() {
            return this.$helpers.isSystemAdministrator() || (this.user.user && this.user.user.id === 424);
        }
    },
    mounted() {
        return this.loadDocuments();
    },
    beforeDestroy() {
        this.requestId += 1;
    },
    watch: {
        type() {
            return this.resetScope();
        },
        connection() {
            return this.resetScope();
        }
    },
    methods: {
        ...mapActions('InTransitDocumentModule', ['listDocuments']),
        resetScope() {
            this.$refs.moduleForm.closeDialog();
            return this.clearSearch();
        },
        rowClick(row) {
            return this.$refs.moduleForm.openDialog(row, this.connection);
        },
        async loadDocuments() {
            const requestId = ++this.requestId;
            const connection = this.connection;
            const type = this.type;
            this.loading = true;
            this.error = '';
            this.documents = [];
            try {
                const response = await this.listDocuments({ connection, type, term: this.appliedTerm, page: this.page, length: this.length });
                if (requestId !== this.requestId || connection !== this.connection || type !== this.type) return;
                if (!response || !Array.isArray(response.data) || !response.meta || !Number.isFinite(Number(response.meta.total))) {
                    throw new Error('Invalid in-transit list response');
                }
                this.documents = response.data;
                this.total = Number(response.meta.total);
            } catch (error) {
                if (requestId !== this.requestId || connection !== this.connection || type !== this.type) return;
                this.error = 'Unable to load in-transit documents. Please try Refresh again.';
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        },
        searchDocuments() {
            if (this.searchTerm.length > 100) {
                this.error = 'Search must be at most 100 characters.';
                return;
            }
            this.appliedTerm = this.searchTerm.trim();
            this.page = 1;
            this.total = 0;
            return this.loadDocuments();
        },
        clearSearch() {
            this.searchTerm = '';
            return this.searchDocuments();
        },
        changePage(page) {
            this.page = page;
            return this.loadDocuments();
        },
        changeLength(length) {
            this.length = length;
            this.page = 1;
            return this.loadDocuments();
        }
    }
};
</script>
